import { FC, useMemo } from "react";
import { Button } from "@radix-ui/themes";
import { ColumnDef } from "@tanstack/react-table";
import { Table } from "@/components/table/table";
import { SyncModelCvrSnapshotSummarySchema } from "@/domains/openapi/types";
import { DateTimeFieldRow } from "@/components/table/datetime-field-row";
import { NumberFieldRow } from "@/components/table/number-field-row";
import { UuidFieldRow } from "@/components/table/uuid-field-row";

interface SyncModelCvrSnapshotsTableProps {
  data: SyncModelCvrSnapshotSummarySchema[];
  onViewSyncModelCvrSnapshot: (id: string) => void;
  pageSize: number;
}

export const SyncModelCvrSnapshotsTable: FC<SyncModelCvrSnapshotsTableProps> = ({
  data,
  onViewSyncModelCvrSnapshot,
  pageSize,
}) => {
  const columns = useMemo<ColumnDef<SyncModelCvrSnapshotSummarySchema>[]>(
    () => [
      {
        header: "Snapshot ID",
        cell: ({ row }) => <UuidFieldRow id={row.original.id} />,
      },
      {
        header: "Version",
        cell: ({ row }) => <NumberFieldRow value={row.original.cvr_version} />,
      },
      {
        header: "Created At",
        cell: ({ row }) => <DateTimeFieldRow dateStr={row.original.internal_created_at} />,
      },
      {
        header: "Actions",
        cell: ({ row }) => (
          <Button
            variant="outline"
            size="1"
            onClick={() => onViewSyncModelCvrSnapshot(row.original.id)}
          >
            View
          </Button>
        ),
      },
    ],
    [onViewSyncModelCvrSnapshot]
  );

  return <Table data={data} columns={columns} pageSize={pageSize} />;
};
